<script lang="ts">
  import { map, tap, startWith, shareReplay } from 'rxjs/operators'
  import { combineLatest } from 'rxjs'
  import Card from '../../Cards/Component.svelte'
  import Players from '../../Players/Listed.svelte'
  import type { Observable } from 'rxjs'
  import type { Player } from '../../shared/codecs/Player'
  import { state } from '../State'
  import { cards, card_count } from '../../Cards/observables'
  import { players } from '../../Players/observables'
  import { vote, current_votes } from './Votes'
  import type { RetroAuthedUser } from '../../Users/types'
  import TopBarPage from '../../Navigation/TopLevelPages/TopBarPage.svelte'
  import LeaderButtons from './LeaderButtons.svelte'
  import type { VoteStatus } from '../../shared/codecs/Vote'
  import type { NonEmptyString } from 'io-ts-types'
  export let user: RetroAuthedUser

  const current_card = combineLatest([cards, state]).pipe(
    map(([cards, state]) => {
      const shuffled_current_card = state.shuffle[state.current_card - 1]
      return shuffled_current_card !== undefined &&
        shuffled_current_card >= 0 &&
        shuffled_current_card < cards.length
        ? cards[shuffled_current_card]
        : {
            id: '',
            heading: '' as NonEmptyString,
            green_text: '' as NonEmptyString,
            amber_text: '' as NonEmptyString,
            red_text: '' as NonEmptyString,
            deleted: true,
          }
    }),
    tap(() => console.log('current_card')),
    shareReplay(1),
  )

  const your_vote = current_votes.pipe(
    map(votes => votes.find(vote => vote.player === user.uid)?.color ?? 'pending'),
    // tap(your_vote => console.log(`your_vote ${your_vote}`)),
    shareReplay(1),
  )

  const resolvedStatus = (vote: VoteStatus | undefined, showing: boolean): VoteStatus => {
    if (!vote) {
      return 'pending'
    }
    if (!showing) {
      return 'cast'
    }
    return vote
  }

  const player_votes: Observable<Player[]> = combineLatest([players, current_votes, state]).pipe(
    map(([players, votes, state]) =>
      players.map(player => {
        const player_vote = votes.find(vote => vote.player === player.uid)
        return {
          ...player,
          vote: resolvedStatus(player_vote?.color, state.show),
        }
      }),
    ),
    startWith<Player[]>([]),
    tap(votes => {
      console.log(`Votes in Vote: ${votes.length}`)
    }),
    shareReplay(1),
  )
</script>

<TopBarPage>
  <div class="game">
    <Players players={$player_votes} />
    <p>Card {$state?.current_card} of {$card_count}</p>

    <div id="card">
      {#if $current_card !== undefined}
        <Card on:vote={e => $vote(e.detail)} {...$current_card} your_vote={$your_vote} />
      {/if}
    </div>
    {#if $state?.leader === user.uid}
      <LeaderButtons {current_card} />
    {/if}
  </div>
</TopBarPage>

<style>
  .game {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
  }
</style>
